export default __webpack_public_path__ + "static/media/arrow.86930443.svg";